import React from 'react';

import { Checkbox } from '@atlaskit/checkbox';

import {
  Table,
  createColumnWidths,
  createColumnsWidths,
  createPredefinedColumnWidths,
} from '@qality/common-components/src/atoms/Table';
import { NoPermissionToViewTestCase } from '@qality/common-components/src/molecules/NoPermissionToViewTestCase';
import { EventUtils } from '@qality/common-utils';

import { Columns, NUMBER_OF_COLUMNS } from '../../TestCaseRepositoryTable';

const DND_COLSPAN = 1;
const CHECKBOX_COLSPAN = 1;
const ACTIONS_COLSPAN = 1;

type Props = { style?: React.CSSProperties };

export const ColumnsWidths = createColumnsWidths<
  Extract<Columns, 'dnd' | 'checkbox' | 'key' | 'menu'>
>({
  dnd: createPredefinedColumnWidths('dnd'),
  checkbox: createPredefinedColumnWidths('checkbox'),
  key: createColumnWidths('94%'),
  menu: createColumnWidths('6%'),
});

export function TestCaseRepositoryNoIssueTableRow({
  style = {},
}: Props): JSX.Element {
  const MESSAGE_COLSPAN =
    NUMBER_OF_COLUMNS - DND_COLSPAN - CHECKBOX_COLSPAN - ACTIONS_COLSPAN;

  return (
    <Table.Tr isHoverable style={style}>
      <Table.Td
        widths={ColumnsWidths.dnd}
        colSpan={DND_COLSPAN}
        data-testid='dnd-cell'
      >
        {/* Empty */}
      </Table.Td>

      <Table.CheckboxTd
        widths={ColumnsWidths.checkbox}
        data-testid='checkbox-cell'
        colSpan={CHECKBOX_COLSPAN}
      >
        <Table.ContentHelper
          justifyContent='center'
          alignItems='center'
          onClick={EventUtils.stopPropagation}
        >
          <Checkbox isChecked={false} isDisabled={true} />
        </Table.ContentHelper>
      </Table.CheckboxTd>

      <Table.Td widths={ColumnsWidths.key} colSpan={MESSAGE_COLSPAN}>
        <Table.ContentHelper alignItems='center'>
          <NoPermissionToViewTestCase />
        </Table.ContentHelper>
      </Table.Td>

      <Table.Td
        widths={ColumnsWidths.checkbox}
        data-testid='actions-cell'
        className='show-on-row-hover'
        colSpan={ACTIONS_COLSPAN}
      >
        {/* Empty */}
      </Table.Td>
    </Table.Tr>
  );
}
